"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toArray = exports.deepMerge = exports.merge = exports.cleanObject = exports.getObject = exports.forceObject = exports.equals = void 0;
var generic_1 = require("./generic");
var __1 = require("..");
/**
 * deepEquals object data with specify keys
 *
 * @param o1 base object
 * @param o2 checking object with o1
 * @param keys only specify key to check, empty means check all. The keys can cover nested object by . (see on example)
 *
 * @returns true if two object is identical
 *
 * @example
 *  equals({a: 1}, {a: 2}, ["a"]) - check only keys 'a'
 *  equals({a: 2, b: 3}, {a: 2, b: 3}) - check all keys ('a' and 'b')
 *  equals({a: {aa: 1, ab: 2}}, {a: {aa: 2, bb: 3, cc: 1}, ["a.ab"]}) - check only 'b' key inside a object
 */
var equals = function (o1, o2, keys) {
    if (keys === void 0) { keys = []; }
    // for deep equals object data
    if (generic_1.isObject(o1) && generic_1.isObject(o2)) {
        // checking all keys
        if (keys.length <= 0) {
            var keys1 = Object.keys(o1);
            var keys2 = Object.keys(o2);
            if (keys1.length !== keys2.length)
                return false; // force not equals when keys is not equals
            if (keys1.length <= 0 && keys2.length <= 0)
                return true; // force equals when empty object passed
            return exports.equals(o1, o2, keys1);
            // checking only specify keys
        }
        else {
            return keys.every(function (key) {
                var value1 = exports.getObject(o1, key);
                var value2 = exports.getObject(o2, key);
                // recusive object again
                if (generic_1.isObject(value1) && generic_1.isObject(value2))
                    return exports.equals(value1, value2, keys.map(function (k) { return k.split(".").slice(1).join("."); }));
                // checking by
                else if (exports.equals(value1, value2))
                    return true;
                return false;
            });
        }
        // normal datatype
    }
    else if (Array.isArray(o1) || Array.isArray(o2)) {
        return __1.array.equals(o1, o2);
    }
    else {
        return o1 === o2;
    }
};
exports.equals = equals;
/**
 * this will convert input to T object
 *
 * @param obj input any type
 * @param def default value if input is not object
 * @return always new object returned
 */
var forceObject = function (obj, def) {
    if (def === void 0) { def = {}; }
    if (generic_1.isObject(obj))
        return Object.assign({}, obj);
    else
        return Object.assign({}, def);
};
exports.forceObject = forceObject;
/**
 *
 * @param obj input object to query
 * @param key object query statment (format as a.b.c)
 * @param all if enable this, getObject will return full object instead of undefined
 */
var getObject = function (obj, key, all) {
    if (all === void 0) { all = false; }
    var _obj = exports.forceObject(obj);
    if (!generic_1.isString(key))
        return all ? _obj : undefined;
    var keys = key.split(".");
    var result = keys.reduce(function (p, k) {
        if (p[k])
            return p[k];
        else
            return p;
    }, _obj);
    // if result is the same as input return 'undefined' or 'input' base on `all`
    if (result !== _obj && generic_1.nonEmpty(result)) {
        return result;
    }
    else {
        return all ? _obj : undefined;
    }
};
exports.getObject = getObject;
/**
 * clean object mean remove undefined and null object
 *
 * @param obj massy object
 */
var cleanObject = function (obj) {
    if (generic_1.noExist(obj))
        return {};
    else
        return Object.keys(obj).reduce(function (p, k) {
            var _a;
            var v = obj[k];
            if (generic_1.isExist(v))
                return __assign(__assign({}, p), (_a = {}, _a[k] = v, _a));
            else
                return p;
        }, {});
};
exports.cleanObject = cleanObject;
var merge = function (base) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (generic_1.noExist(base))
        return undefined;
    var newObjectList = obj.map(function (o) { return exports.cleanObject(o); });
    return Object.assign.apply(Object, __spreadArrays([exports.cleanObject(base)], newObjectList));
};
exports.merge = merge;
var deepMerge = function (_jsonA, _jsonB, size) {
    if (size === void 0) { size = 20; }
    var jsonA = exports.forceObject(_jsonA);
    var jsonB = exports.forceObject(_jsonB);
    return [jsonB].reduce(function (prev, obj) {
        Object.keys(obj).forEach(function (key) {
            var pVal = prev[key];
            var oVal = obj[key];
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat.apply(pVal, oVal);
            }
            else if (generic_1.isObject(pVal) && generic_1.isObject(oVal) && size > 0) {
                prev[key] = exports.deepMerge(pVal, oVal, size - 1);
            }
            else {
                // replace only when new value is exist
                if (generic_1.isExist(oVal))
                    prev[key] = oVal;
            }
        });
        return prev;
    }, jsonA);
};
exports.deepMerge = deepMerge;
var toArray = function (json) {
    return Object.keys(json)
        .sort(function (k1, k2) {
        var _a, _b;
        var v1 = (_a = json[k1]) !== null && _a !== void 0 ? _a : { index: -1, data: "" };
        var v2 = (_b = json[k2]) !== null && _b !== void 0 ? _b : { index: -1, data: "" };
        if (v1.index > v2.index)
            return 1;
        else if (v1.index < v2.index)
            return -1;
        else
            return 0;
    })
        .map(function (k) { var _a, _b; return (_b = (_a = json[k]) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : ""; })
        .reduce(function (p, c) { return (Array.isArray(c) ? __spreadArrays(p, c) : __spreadArrays(p, [c])); }, []);
};
exports.toArray = toArray;
//# sourceMappingURL=json.js.map